import React, { Component } from 'react';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';

class OrderList extends Component {
    state = {
        confirmedOrder: [
            {
                id: 0,
                code: 'SO001',
            },
            {
                id: 1,
                code: 'SO002',
            },
            {
                id: 2,
                code: 'SO003',
            },
        ],
        clickerOrder: 'SO001'
    }

    _updateStatus(code) {
        this.setState({
            clickerOrder: code
        });
    }

    render() {
        return (
            <View style={styles.content}>
                <Text style={styles.titleList}>
                    {
                        "Confirmed Order History"
                    }
                </Text>
                {
                    this.state.confirmedOrder.map((item, index) => (
                        <TouchableOpacity
                            key={item.id}
                            style={
                                (this.state.clickerOrder === item.code)
                                    ? [styles.container, { backgroundColor: '#c8e1ff' }]
                                    : styles.container
                            }
                            onPress={() => {
                                this.props.onPress(item.code);
                                this._updateStatus(item.code);
                            }}>
                            <Text style={
                                (this.state.clickerOrder === item.code)
                                    ? [styles.text, { fontWeight: 'bold' }]
                                    : styles.text
                            }>
                                {item.code}
                            </Text>
                        </TouchableOpacity>
                    ))
                }
            </View>
        )
    }
}

const styles = StyleSheet.create({
    content: {
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 20,
        alignItems: 'center',
    },
    titleList: {
        padding: 10,
        //ackgroundColor: '#d9f9b1',
        alignItems: 'center',
        borderColor: '#c8e1ff',
        height: 50,
        fontWeight: 'bold',
        fontSize: 20,
    },
    container: {
        padding: 10,
        alignItems: 'center',
        borderColor: '#c8e1ff',
        height: 40,
        flexDirection: 'row'
    },
    text: {
        color: '#4f603c',
    }
})

export default OrderList;



// WEBPACK FOOTER //
// ./src/pages/ch5/OrderList.js